// extracted by mini-css-extract-plugin
module.exports = {"tagList":"ManageTagTab_tagList__2RQaI"};